import { gql } from "apollo-boost"

export default gql`
  query OrderDetails_ShopCart($id: ID!) {
    order(id: $id) {
      id
      orderDetails {
        id
        quantity
        unitPrice
        sum
        product {
          id
          photoUrl
          name
        }
      }
    }
  }
`
